module.exports = __webpack_public_path__ + "img/profile-icon.df39d003.svg";